import React from 'react';
import { useLocation } from 'react-router-dom';
import { NAV } from './Sidebar.jsx';
import { useData } from '../../lib/DataContext.jsx';
import { fmt, fmtCr, fmtInt, bandColor } from '../../lib/format.js';
import { ProvenanceLegend } from '../ui/kits.jsx';

export default function Topbar() {
  const { data } = useData();
  const loc = useLocation();
  const pageId = loc.pathname.replace('/', '') || 'overview';
  const item = NAV.find((n) => n.id === pageId) || NAV[0];

  const po = data?.meta?.programmeOverall;
  const poBand = data?.kpi?.programmeBand;

  return (
    <header className="topbar" data-testid="topbar">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1, minWidth: 0 }}>
        <div className="crumb" data-testid="topbar-crumb">{item.crumb}</div>
        <div className="page-title" data-testid="topbar-title" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {item.title}
        </div>
      </div>

      {data && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <ProvenanceLegend />
          <div style={{ width: 1, height: 20, background: 'var(--line)' }} />
          <div className="chip tabular" style={{ background: `${bandColor(poBand)}18`, color: bandColor(poBand) }} data-testid="chip-programme-score">
            <span style={{ width: 6, height: 6, background: bandColor(poBand), borderRadius: '50%' }} />
            Programme {fmt(po, 2)} · {poBand}
          </div>
          <div className="chip tabular" data-testid="chip-projects">
            Projects {fmtInt(data.kpi.totalProjects)}
          </div>
          <div className="chip tabular" data-testid="chip-budget" style={{ background: '#fbe7e3', color: '#b62e1c' }}>
            Budget {fmtCr(data.kpi.totalBudgetCr)}
          </div>
        </div>
      )}
    </header>
  );
}
